/* eslint-disable import/no-default-export */
import { LanguagePicker } from './LanguagePicker';
export default LanguagePicker;
